import { render } from "./TicketColumn.vue?vue&type=template&id=9904d758"
import script from "./TicketColumn.vue?vue&type=script&lang=js"
export * from "./TicketColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__